import React, { useState } from 'react';
import TableRow from '@material-ui/core/TableRow';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import clsx from 'clsx';
import { Endpoints } from 'UI/constants/endpoints';

import Cell from './Cell';
import { COACH_MAP, MAIN_COLUMN_ID } from './columns';
import { ExpandableRow } from './ExpandableRow';
import { useStyles } from './styles';

export const Row = ({ columns, row, queryParams }) => {
  const classes = useStyles();
  const [rowSelection, setRowSelection] = useState({ coach: '', expanded: false });

  const isGpacOrRegionalRow = [COACH_MAP.gpac, COACH_MAP.regional].includes(row.team);

  const handleClickExpandButton = () =>
    setRowSelection(prev => ({ coach: row.team, expanded: !prev.expanded }));

  return (
    <>
      <TableRow className={isGpacOrRegionalRow ? '' : classes.rowColor}>
        <td
          className={clsx({
            [classes.commonCell]: true,
            [classes.expandableButton]: !isGpacOrRegionalRow,
            [classes.gpacRow]: row.team === COACH_MAP.gpac,
            [classes.regionalRow]: row.team === COACH_MAP.regional
          })}
        >
          {!isGpacOrRegionalRow && (
            <div
              onClick={handleClickExpandButton}
              role="button"
              tabIndex={0}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  handleClickExpandButton();
                }
              }}
            >
              {rowSelection.expanded ? <ExpandMoreIcon /> : <ChevronRightIcon />}
            </div>
          )}
        </td>

        {columns.map(col => (
          <Cell
            key={col.id}
            className={clsx({
              [classes.commonCell]: true,
              [classes.stickyColumn]: col.id === MAIN_COLUMN_ID,
              [classes.gpacRow]: row.team === COACH_MAP.gpac,
              [classes.regionalRow]: row.team === COACH_MAP.regional,
              [classes.bold]: col.id === MAIN_COLUMN_ID
            })}
            mainLabel={
              row.team === COACH_MAP.regional && col.id === MAIN_COLUMN_ID
                ? row.regional
                : row[col.id]
            }
            secondaryLabel={col?.subLabelId && row[col.subLabelId]}
          />
        ))}
      </TableRow>

      {rowSelection.expanded && (
        <ExpandableRow
          columns={columns}
          endpoint={`${
            Endpoints.ToolsUsageReportRecruitersV2
          }?${queryParams}&coach=${encodeURIComponent(rowSelection.coach)}`}
        />
      )}
    </>
  );
};
